import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SelectFormatCallback, SelectItem } from './select.service';
import { ChangedItemsEvent, SelectComponent } from './select.component';
import { HubstaffProjectDTO } from '../../core/models/hubstaff-entities.model';

export interface ChangedProjectsEvent {
  selectedProjects: HubstaffProjectDTO[];
}

@Component({
  selector: 'app-select-project',
  template: `<app-select
    [id]="'select-project'"
    [enabled]="placeholder !== 'loading...'"
    [placeholder]="'Select project'"
    [items]="items"
    [format]="format"
    [showClearAll]="true"
    [initItemIds]="initItemIds"
    (changeEvent)="handleSelectedItems($event)"
  ></app-select>`,
  imports: [SelectComponent],
})
export class SelectProjectComponent implements OnChanges {
  @Input() projects: HubstaffProjectDTO[] = [];
  @Input() selectedProject?: HubstaffProjectDTO | null = null;
  @Input() placeholder = '';
  @Output() changedProjectsEvent = new EventEmitter();
  items: SelectItem[] = [];
  initItemIds: string[] = [];
  format: SelectFormatCallback = (state: SelectItem) => '';

  ngOnChanges(): void {
    this.format = (state: SelectItem) => {
      if (!state.id) return state.text;
      const currentProject = this.projects.find(project => project.id === state.id);

      return currentProject ? currentProject.name : state.text;
    };

    if (this.selectedProject) {
      this.initItemIds = [this.selectedProject.id];
    }

    this.items = this.projects.map(project => {
      return {
        id: project.id,
        text: project.name,
      };
    });
  }

  handleSelectedItems(event: ChangedItemsEvent): void {
    const selectedProjects = this.projects.filter(project => {
      return event.selectedItems.includes(project.id);
    });

    this.changedProjectsEvent.emit({ selectedProjects });
  }
}
